import React from 'react';

/**
 * Premium segmented toggle for unit systems or other 2/3-way switches.
 * Props:
 *   value: current value
 *   options: [{ value, label }]
 *   onChange: (val) => void
 *   label: accessible label
 *   testIdPrefix: prefix for data-testid on each option
 */
const UnitToggle = ({ value, options, onChange, label, testIdPrefix = 'toggle' }) => {
  return (
    <div role="radiogroup" aria-label={label} className="inline-flex p-1 bg-slate-800/70 border border-slate-700 rounded-full">
      {options.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(opt.value)}
            data-testid={`${testIdPrefix}-${opt.value}`}
            className={`px-3.5 sm:px-4 py-1.5 rounded-full text-xs sm:text-sm font-medium transition-all ${
              active
                ? 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white shadow shadow-blue-500/20'
                : 'text-slate-400 hover:text-white'
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default UnitToggle;
